import { Stack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  PublicBidStatus,
  type BuyerPublicBidDetailDto,
} from "../../../../autogen/bff-api";
import { parseCriterionKey } from "../../../../common/qualification/criterionKey";
import { BidActionsCard } from "./BidActionsCard";
import { BidActivityTimeline } from "./BidActivityTimeline";
import { BidContactCard } from "./BidContactCard";
import type { BidEvaluationSummary } from "./bidEvaluationSummary";
import { getBidQualificationRows } from "./bidQualification";
import { BidRejectionActionCard } from "./BidRejectionActionCard";
import { QualificationsReviewProgressCard } from "./QualificationsReviewProgressCard";

interface Props {
  detail: BuyerPublicBidDetailDto;
  summary: BidEvaluationSummary;
  onMarkWinner: () => void;
  onOpenRejectionDetails?: () => void;
}

export const BidDetailSidebar = ({
  detail,
  summary,
  onMarkWinner,
  onOpenRejectionDetails,
}: Props) => {
  const navigate = useNavigate();
  return (
    <Stack spacing="4">
      {detail.bid.status === PublicBidStatus.Rejected ? (
        <BidRejectionActionCard
          detail={detail}
          onViewRejectionDetails={onOpenRejectionDetails}
        />
      ) : (
        <BidActionsCard detail={detail} summary={summary} onMarkWinner={onMarkWinner} />
      )}
      <BidContactCard detail={detail} />
      <QualificationsReviewProgressCard
        items={getBidQualificationRows(detail).map((r) => ({
          name: parseCriterionKey(r.criterionKey).name,
          verdict: r.buyerVerdict ?? null,
        }))}
        onSeeAll={() => navigate(`?tab=qualifications`, { replace: false })}
      />
      <BidActivityTimeline detail={detail} />
    </Stack>
  );
};
